import React, { useContext, useEffect, useState } from 'react'
import '../../components/template/template.scss'
import { AppContext } from '../../context/app'
import useAxios from 'axios-hooks'
import { CUSTOM_PAGES_API } from '../../utils/apiUrls'
import { useLocation, useNavigate, useParams } from 'react-router'
import { withTheme } from 'theming'
import ReactHtmlParser from 'react-html-parser'
import { isEmpty } from 'lodash'
import 'react-quill/dist/quill.snow.css'
import './customPage.css'
import ContentListingPage from './contentListingPage'
import CustomPricingPage from './customPricingPage'
import { ComponentConfig } from '../../utils/componentConfig'
import CustomPageShare from '../../assets/imgComponents/customPageShare'
import ShareModal from '../../components/shareModal/shareModal'
import { create_share_url } from '../../utils/helper'

const CustomPage = ({ theme }) => {
  const pageURL = useParams().pageURL
  const location = useLocation()
  const [componentData, setComponentData] = useState([])
  const [htmlData, setHtmlData] = useState('')
  const { setLoader, componentCustomForms } = useContext(AppContext)
  const [pageData, setPageData] = useState({})
  const [socialSharing, setSocialSharing] = useState({})
  const [shareModal, setShareModal] = useState(false)
  const navigate = useNavigate()

  const [{ data: pagesList, loading: pagesListLoading }, pagesListCall] = useAxios(
    {
      url: CUSTOM_PAGES_API,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    pagesListCall({
      url: `${CUSTOM_PAGES_API}/${pageURL}`,
    })
    setSocialSharing({})
  }, [location.pathname, pageURL])

  useEffect(() => {
    setLoader(pagesListLoading)
  }, [pagesListLoading])

  useEffect(() => {
    if (pagesList && pagesList.success && pageURL) {
      if (location.pathname.split('/')[1] === 'custom') {
        let pageObj = pagesList?.data
        if (!pageObj) {
          navigate('/home')
        }

        if (!isEmpty(pageObj?.social_share)) {
          setSocialSharing(pageObj?.social_share)
        }
        setPageData(pageObj)
        setComponentData(pageObj?.components)
      }
      if (location.pathname.split('/')[1] === 'static') {
        let pageObj = pagesList?.data
        if (!pageObj) {
          navigate('/home')
        }
        if (!isEmpty(pageObj?.social_share)) {
          setSocialSharing(pageObj?.social_share)
        }
        setPageData(pageObj)
        setHtmlData(pageObj?.content)
      }
      if (location.pathname.split('/')[1] === 'content-listing') {
        let pageObj = pagesList?.data
        if (!pageObj) {
          navigate('/home')
        }
        setPageData(pageObj)
        setComponentData(pageObj?.components)
      }
      if (location.pathname.split('/')[1] === 'pricing-page') {
        let pageObj = pagesList?.data
        if (!pageObj) {
          navigate('/home')
        }
        setPageData(pageObj)
      }
      if (location.pathname.split('/')[1] === 'e-comm-page') {
        let pageObj = pagesList?.data
        if (!pageObj) {
          navigate('/home')
        }
        setPageData(pageObj)
        setComponentData(pageObj?.components)
      }
    }
  }, [pagesList])

  const getComponent = (key, data) => {
    if (!key) return
    let componentProps = {
      componentData: data,
      modifyData: () => {},
      setModalState: () => {},
      isEdit: false,
      onSwap: () => {},
      onDelete: () => {},
      onCopy: () => {},
      onAdd: () => {},
    }
    if (key === 'customForm') {
      const CustomForm = ComponentConfig[key]
      return <CustomForm {...componentProps} formData={componentCustomForms} />
    }

    if (key === 'artistMaxPlayer') {
      const ArtistMax = ComponentConfig.artistMax
      return <ArtistMax {...componentProps} isPlayer={true} />
    }

    if (key === 'artistMaxWithoutText') {
      const ArtistMax = ComponentConfig.artistMax
      return <ArtistMax {...componentProps} isPlayer={true} withoutText={true} />
    }

    // Default case
    const Component = ComponentConfig[key]
    return Component ? <Component {...componentProps} /> : null
  }

  return (
    <div className="relative">
      {pageData?.type === 'CONTENT_LISTING' && (
        <ContentListingPage
          pageData={pageData}
          componentData={pageData?.components}
          data={pageData?.content}
        />
      )}
      {pageData?.type === 'PRICING' && (
        <CustomPricingPage pageData={pageData} data={pageData?.content} />
      )}
      {pageData?.type === 'ECOMMERCE_CUSTOM' &&
        componentData.map((info, index) => getComponent(info?.data?.component_key, info?.data))}
      {pageData?.type === 'CUSTOM' &&
        componentData.map((info, index) => getComponent(info?.data?.component_key, info?.data))}
      {pageData?.type === 'STATIC' && (
        <div className={`bg-no-repeat bg-right bg-contain mb-15 mt-4 custom-page ql-editor `}>
          <div style={{ color: theme.c4 }} className="md:mt-8 px-8 md:px-20">
            {!isEmpty(pageData) && ReactHtmlParser(htmlData)}
          </div>
        </div>
      )}
      {!isEmpty(socialSharing) && socialSharing?.enabled ? (
        <div
          style={{
            background: socialSharing.bg_color,
            width: '42px',
            height: '42px',
            right: '7%',
            zIndex: '20',
            bottom: '106px',
          }}
          className="rounded-full flex justify-center items-center fixed cursor-pointer"
          onClick={() => setShareModal(true)}
        >
          <CustomPageShare color={socialSharing.icon_color} />
        </div>
      ) : null}
      {shareModal && (
        <ShareModal onClose={() => setShareModal(false)} link={create_share_url()} detailObj={{}} />
      )}
    </div>
  )
}

export default withTheme(CustomPage)
